import PropTypes from 'prop-types';
import React from 'react';

import AccordionWrapper from 'App/components/AccordionWrapper/AccordionWrapper';
import withFormikFields, { fieldHelpersPropType } from 'Shared/form/withFormikFields';

const QuestionAccordionWrapper = ({ questionId, statePath, fieldValues, fieldHelpers, ...rest }) => {
    const sectionExpanded = fieldValues[`questionsExpanded.${questionId}.${statePath}`];
    const { setValue } = fieldHelpers[`questionsExpanded.${questionId}.${statePath}`];
    return (
        <AccordionWrapper
            {...rest}
            stateKey={`assessmentManagerQuestionExpanded.${questionId}.${statePath}`}
            controlledVisible={sectionExpanded}
            onClick={setValue}
            keepMounted
        />
    );
};

QuestionAccordionWrapper.propTypes = {
    questionId: PropTypes.string.isRequired,
    statePath: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    fieldValues: PropTypes.shape({}).isRequired,
    fieldHelpers: fieldHelpersPropType.isRequired,
};

export default withFormikFields({
    WrappedComponent: QuestionAccordionWrapper,
    fieldNames: [(props) => `questionsExpanded.${props.questionId}.${props.statePath}`],
});
